import clsx from 'clsx';

import styles from './FilterList.module.scss';

export interface FilterListProps {
  className?: string;
  list?: string[];
  title?: string;
}

export const FilterList = ({
  className,
  list = [],
  title,
}: FilterListProps) => {
  if (!list.length) {
    return null;
  }

  return (
    <div
      data-testid="filter-list"
      className={clsx(styles.filterListRoot, className)}
    >
      {title && <p>{title}</p>}
      <ul>
        {list.map(name => (
          <li key={name}>{name}</li>
        ))}
      </ul>
    </div>
  );
};
